import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';
import styles from './Burger.css';

const cx = classnames.bind(styles);

function Burger({ className, isOpen, onClick }) {
    const { t } = useTranslation();
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <button
            type='button'
            className={classes}
            aria-expanded={isOpen}
            aria-label={isOpen ? t('common.closeMenu') : t('common.openMenu')}
            onClick={onClick}
        >
            <Icon name={isOpen ? 'close' : 'menu'} className={styles.icon} />
        </button>
    );
}

Burger.propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

Burger.defaultProps = {
    className: '',
    isOpen: false
};

export {
    Burger
};
